import React from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import api from '../../ApiService';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';

import { ModalOKCancel } from '../../modals';

import { toast } from 'react-toastify';


export default class Providers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            providers: [],
            loadingProviders: true,
            showCancelModal: false,
            isDirty: false
        };
    }

    componentDidMount = async () => {
        this.props.alertProvidersComponentOfHospitalChange(this.alertProvidersComponentOfHospitalChange);

        this.setState({ selectedHospital: this.props.selectedHospital }, this.loadProviders);
    }

    loadProviders = async () => {
        this.setState({ loadingProviders: true });
        let providers = await api.getProviders(this.props.selectedHospital.nameHash);

        this.setState({
            providers,
            loadingProviders: false
        });
    }

    alertProvidersComponentOfHospitalChange = (hospital) => {
        this.setState({ selectedHospital: hospital }, this.loadProviders);
    }

    onConfirmCancel = async (e) => {
        let providers = this.loadProviders();
        this.setState({
            providers,
            isDirty: false
        });
        toast.success("Changes canceled.");
    }

    onClickCancel = async (e) => {
        e.preventDefault();
        if (!this.state.isDirty) {
            await this.onConfirmCancel();
            return;
        }
        else {
            this.setState({ showCancelModal: true });
        }
    }

    onClickSave = async () => {
        let items = this.state.providers;
        let success = await api.saveProviders(items);
        if (success) {
            await this.loadProviders();
            this.setState({
                isDirty: false
            });
            toast.success(`Providers updated.`);
        }
    }

    onEditorValueChange = (e) => {
        // just set the dirty flag
        if (!this.state.isDirty) this.setState({ isDirty: true });
    }

    onEditorBlur = (e, props) => {
        if (e.target.defaultValue === e.target.value) return;

        let items = [...props.value];
        if (items[props.rowIndex][props.field] !== e.target.value) {
            items[props.rowIndex][props.field] = e.target.value;
            this.setState({ items });
        }
    }

    onEditorKeyPress = (e, props) => {
        // have to manually handle this since onBlur doesn't make it to our control
        // yes, i'm a little upset about that
        // 9 - tab
        // 13- enter
        if (e.keyCode === 9 || e.keyCode === 13) {
            this.onEditorBlur(e, props);
        }
    }

    editTemplate = (props) => {
        return (
            <InputText type='text' defaultValue={props.rowData[props.field]}
                onBlur={(e) => this.onEditorBlur(e, props)}
                onChange={(e) => this.onEditorValueChange(e)}
                onKeyDown={(e) => this.onEditorKeyPress(e, props)}
            />
        );
    }

    onCheckBoxValueChange = (e, rowData, field) => {
        let providers = this.state.providers.slice();
        let index = providers.findIndex(x => x.id === rowData.id);
        providers[index][field] = e.target.checked;

        this.setState({
            isDirty: true,
            providers
        });
    }

    checkBoxTemplate = (rowData, props) => {
        return (
            <Checkbox
                checked={rowData[props.field]}
                onChange={(e) => this.onCheckBoxValueChange(e, props.rowData, props.field)}
                value={`providers[${props.rowIndex}][${props.field}]`}
                color="primary"
            />
        );
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.onClickCancel} disabled={!this.state.isDirty}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    }

    currencyTemplate = (rowData, column) => {
        return <div style={{ textAlign: 'right' }}>{this.formatCurrency(rowData[column.field])}</div>;
    }

    renderDetailsTable() {
        if (this.state.loadingProviders)
            return <em>Loading...</em>;
        return (
            <div>
                <DataTable responsive value={this.state.providers} editable>
                    <Column field="site" header="Site Name" sortable="true" style={{ width: '10%' }} />
                    <Column field="sourceProvider" header="Source Provider" sortable="true" style={{ width: '10%' }} />
                    <Column field="name" header="Name" sortable="true" style={{ width: '20%' }} editor={this.editTemplate} />
                    <Column field="revenue" header="Revenue (12mo)" sortable="true" style={{ width: '5%' }} body={this.currencyTemplate} />
                    <Column field="confirmed" header="Confirmed" sortable="true" style={{ textAlign: 'center', width: '5%' }} body={this.checkBoxTemplate} />
                    <Column field="active" header="Active" sortable="true" style={{ textAlign: 'center', width: '5%' }} body={this.checkBoxTemplate} />
                </DataTable>
                <br />
            </div>
        );
    }

    renderCancelModal = () => {
        return (
            <ModalOKCancel
                title={"Discard changes"}
                body={"You have unsaved changes. Click OK to discard your changes."}
                show={this.state.showCancelModal}
                onOK={() => { this.onConfirmCancel(); this.setState({ showCancelModal: false }); }}
                onCancel={() => this.setState({ showCancelModal: false })}
            />
        );
    }

    render() {
        let mappingDetails = this.renderDetailsTable();
        return (
            <div>
                <h3>Providers</h3>
                <hr />
                {this.renderSaveCancel(12)}
                <br />
                <br />
                {mappingDetails}
                <br />
                <br />
                {this.renderSaveCancel(12)}

                {this.renderCancelModal()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Hospitals/Providers.js